import alt from '../alt';


class ReportActions {
    constructor() {
        this.generateActions('getReportsSuccess', 'getReportsFail', 'clearReports');
    }

}

export default alt.createActions(ReportActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/ReportActions.js
 **/